export default __webpack_public_path__ + "static/media/empty-gift.436a48a9.svg";